export default "__VITE_ASSET__DZcypYBH__"